

















































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';

@Component
export default class CardProfitLoss extends CompanyMixin {
    rows: any = [
        {text: 'Nettoomsättning',                       values: ['A', 'C'],     styles: ['']},
        {text: 'Övriga rörelseintäkter',                values: ['B', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Summa intäkter',                        values: ['C', 'C'],     styles: ['sum', 'bline', 'line']},
        {text: '',                                      values: [],     styles: []},
        {text: 'Kostnader för varor och material',      values: ['D', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Bruttoresultat',                        values: ['E', 'C'],     styles: ['sum2', 'line', 'line']},
        {text: 'Övriga externa kostnader',              values: ['F', 'C'],     styles: ['']},
        {text: 'Personalkostnader',                     values: ['G', 'C'],     styles: ['']},
        {text: 'Övriga rörelsekostnader',               values: ['H', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Driftsresultat',                        values: ['I', 'C'],     styles: ['sum2', 'line', 'line']},
        {text: 'Av- och nedskrivningar',                values: ['J', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Rörelseresultat',                       values: ['K', 'C'],     styles: ['sum', 'bline', 'line']},
        {text: '',                                      values: [],     styles: []},
        {text: 'Finansiella intäkter',                  values: ['L', 'C'],     styles: ['']},
        {text: 'Finansiella kostnader',                 values: ['M', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Resultat efter finansiella poster',     values: ['N', 'C'],     styles: ['sum2', 'line', 'line']},
        {text: 'Bokslutsdispositioner',                 values: ['O', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Resultat före skatt',                   values: ['P', 'C'],     styles: ['sum2', 'line', 'line']},
        {text: 'Skatt på årets resultat',               values: ['Q', 'C'],     styles: ['', 'line', 'line']},
        {text: 'Årets resultat',                        values: ['R', 'C'],     styles: ['sum', 'bline', 'line']},
    ];
    cols: any = [];

    val(i: number, row: any) {
        const name = row.values[0];
        if (name === undefined) {
            return '';
        }
        return this.profitloss.sheets[i][name];
    }

    part(i: number, row: any) {
        const name1 = row.values[0];
        const name2 = row.values[1];
        if (name1 === undefined || name2 === undefined) {
            return '';
        }
        const n1 = Number(this.profitloss.sheets[i][name1]);
        const n2 = Number(this.profitloss.sheets[i][name2]);
        if (n2 === 0) {
            return 0;
        }
        return n1 / n2;
    }

    title(i: number) {
        return this.profitloss.sheets[i].DATE_TO.substr(0, 7) + ' (' + this.profitloss.sheets[i].MONTHS + ' mån)';
    }

    @Watch('profitloss', { immediate: true, deep: true })
    onProfitlossChanged(newVal: any, oldVal: any) {
        this.cols.splice(0, this.cols.length);
        if (this.profitloss !== undefined) {
            for (let i = 0; i < this.profitloss.count; i++) {
                this.cols.push(i);
            }
        }
    }

}
